import React from 'react';

class Input extends React.Component {
    state = {
        value: this.props.value || '',
    }

    handleChange(value) {
      this.setState({
          value: value
      });

      if (this.props.handleChange) {
        this.props.handleChange(value);
      }
    }

    render() {
        return (
            <input
                type={ this.props.type ? this.props.type : 'text' }
                name={ this.props.name }
                placeholder={ this.props.placeholder }
                className={ this.props.class ? this.props.class : '' }
                onChange={(event) => this.handleChange(event.target.value)}
                value={ this.state.value }
            />
        )
    }
}

export default Input;
